export enum ClaimStatus {
  INITIAL = 'initial',
  SUCCESS = 'success',
  PENDING = 'pending',
  ERROR = 'error'
}

export enum ClaimProgress {
  UPDATE_REWARD,
  CLAIM_REWARD,
  PENDING,
  CONFIRMING,
  SUCCESS,
  ERROR,
  LOADING
}

export enum ClaimRewardActionType {
  CLAIM_REWARD,
  UPDATE_REWARD
}
